import { useMutation } from 'react-query';
import { useApiPost, useApiQuery } from 'src/api';
import { useBuildVars } from 'src/config';

export type VpnListQueryRequest = {
  VpnId: number;
};

export type VpnListQuerResponse = {
  isProductMemberExclude: string;
  productMemberType: string;
  productMembers: string[];
};
export type Product = {
  Id: number;
  productMember: string;
};

export type VpnAddQueryRequest = {
  dealId: string;
  discountDetailId: number;
  isProductMemberExclude: string;
  productMemberType: string;
  productMembers: string[];
  sbo2ProductSetId: number;
  vendorProgramId: number;
};

export function commaSeparatedValue(rows: Product[], inputValue: string) {
  const value = inputValue
    .split(',')
    .map((item) => item.trim())
    .filter((item) => item);
  const newItems: Product[] = value.map((name, index) => ({
    Id: rows.length + index,
    productMember: name,
  }));
  return newItems;
}
export function mergedUniqueList(
  rows: Product[],
  newItem: Product[]
): Product[] {
  const allItems = [...rows, ...newItem];
  const uniqueMap = new Map<string, { Id: number; productMember: string }>();
  allItems.forEach((item) => {
    if (!uniqueMap.has(item.productMember)) {
      uniqueMap.set(item.productMember, item);
    }
  });
  const result = Array.from(uniqueMap.values()).map((item, index) => ({
    Id: index,
    productMember: item.productMember,
  }));
  return result;
}
export function useVpnListQuery(params: VpnListQueryRequest, enabled: boolean) {
  const buildVars = useBuildVars();
  return useApiQuery<VpnListQuerResponse>(
    `/system.webapi.gds/api/v1/GdsCoreApiProductInclusionExclusion/${params.VpnId}`,
    undefined,
    { enabled },
    undefined,
    {
      host: buildVars.VP_API_BASE,
    }
  );
}
export function useAddVpnUpdate(request: VpnAddQueryRequest) {
  const buildVars = useBuildVars();
  const apiPost = useApiPost<string>({
    host: buildVars.VP_API_BASE,
  });
  return useMutation(() =>
    apiPost(
      '/system.webapi.gds/api/v1/GdsCoreApiProductInclusionExclusion',
      request
    )
  );
}
